<template>
  <div class="good-box">
    <h4>{{$I18n("get_shop_config")}}</h4>
    <p>{{$I18n("get_shop_con_info")}}</p>
    <div class="good-select-div">
      <label>{{$I18n('cloud_sto_service')}}</label>
      <div>
        <md-field>
          <md-select v-model="sto">
            <md-option :value="'_'">{{$I18n('none')}}</md-option>
            <md-option v-for="item in cloud_sto" :key="item.id" :value="item.id">{{item.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="good-select-div">
      <label>{{$I18n('live_service')}}</label>
      <div>
        <md-field>
          <md-select v-model="live">
            <md-option :value="'_'">{{$I18n('none')}}</md-option>
            <md-option v-for="item in live" :key="item.id" :value="item.id">{{item.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <div class="good-select-div">
      <label>{{$I18n('cloud_id_service')}}</label>
      <div>
        <md-field>
          <md-select v-model="cid">
            <md-option :value="'_'">{{$I18n('none')}}</md-option>
            <md-option v-for="item in cloud_id" :key="item.id" :value="item.id">{{item.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pk : {
      type: String,
      default: "",
    },
  },
  data(){
    return {
      init: true,
      sto: "_",
      live: "_",
      cid: "_",

      cloud_sto: [],
      live_good: [],
      cloud_id: [],
    }
  },
  mounted: function(){
    this.api_getAllGood()
      .then(this.api_getGoodSet)
      .then(() => {
        this.init = false;
      });
  },
  computed:{ 
    cloud_sto_id: function(){
      return this.cloud_sto.map(i => i.id);
    }, 
    live_good_id: function(){
      return this.live_good.map(i => i.id);
    }, 
    cloud_id_id: function(){
      return this.cloud_id.map(i => i.id);
    },
  },
  watch:{
    sto: function(){
      this.modal_submit();
    },
    live: function(){
      this.modal_submit();
    },
    cid: function(){
      this.modal_submit();
    },
  },
  methods: {
    // 提交 商品配置
    modal_submit(){
      if(this.init){
        return
      }
      var postData = [];
      if(this.sto !== "_"){
        postData.push(this.sto)
      }
      if(this.live !== "_"){
        postData.push(this.live)
      }
      if(this.cid !== "_"){
        postData.push(this.cid)
      }
      this.$api.setGiveGood({
        ids: postData,
        pk : this.pk,
        link_type: 4,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"));
          this.api_getGoodSet();
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 获取对应APP的商品列表
    api_getGoodSet(){
      this.form = [];
      return this.$api.getBindGood({
        // "seller_id"  : "",
        "pk"         : this.pk,
        "link_type"  : 4,
        "page_no"    : 1,
        "page_size"  : 9999,
      })
        .then(this.$Then(res => {
          res.data.forEach(item => {
            if(this.cloud_sto_id.includes(item.link_id)){
              this.sto = item.link_id;
            }else if(this.live_good_id.includes(item.link_id)){
              this.live = item.link_id;
            }else if(this.cloud_id_id.includes(item.link_id)){
              this.cid = item.link_id;
            }
          })
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },

    // 获取所有的Good
    api_getAllGood(){
      return this.$api.getGood({
        "seller_id"  : "",
        "app_id"     : "",
        "category_id": 0,
        "page_index" : 1,
        "page_size"  : 9999,
        "link_type"  : 4,
      })
        .then(this.$Then(res => {
          res.data.forEach(item => {
            if(item.category_id === 101){
              this.cloud_sto.push({
                ...item,
              })
            }else if(item.category_id === 107){
              this.live_good.push({
                ...item,
              })
            }else if(item.category_id === 103){
              this.cloud_id.push({
                ...item,
              })
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
}
</script>
<style lang="scss" scoped>
  .good-box{
    text-align: left;
    >h4{
      font-weight: 600;
      margin-bottom: 0px;
    }
    >p{
      color: #666666;
    }
  }
  .good-select-div{
    display: flex; 
    align-items: center;
    >label{
      width: 160px;
    }
    >div{
      width: 300px;
    }
  }
  .left-transfer-item{
    margin-right : 24px;
  }
  .left-transfer-item,
  .right-transfer-item{
    text-align: left;
    display: inline-block;
  }
  .right-button{
    float: right;
  }
</style>